import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import FounderMessage from '../Components/leadership/FounderMessage'
import { Helmet } from "react-helmet-async";
function OurFounder() {
    return (
        <div>
            <Helmet>
    <title>
        Message from Our Founder | Mobikode
    </title>

    <meta
        name="description"
        content="Read the message from Mobikode's founder and learn about the vision, values, technology-driven approach, and commitment behind the company's journey."
    />

    <meta
        name="keywords"
        content="Mobikode Founder, Message from Our Founder, Mobikode Founder Message, About Mobikode Founder, Mobikode Vision, Mobikode Leadership, Technology Leadership, Digital Transformation Leadership, Mobikode Company"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/our-founder"
    />

    <meta
        property="og:title"
        content="Message from Our Founder | Mobikode"
    />

    <meta
        property="og:description"
        content="Discover the vision and values behind Mobikode through a message from our founder."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/our-founder"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/sales/bg3.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Message from Our Founder | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Learn about Mobikode's vision, values, and journey through a message from our founder."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/sales/bg3.png"
    />
</Helmet>
            <WhoHero
                title="Message from Our Founder"
                // text="Technology. Transformation. Trust."
                imgData="/assets/sales/bg3.png"
            />
            <FounderMessage />
        </div>
    )
}

export default OurFounder
